export const clickOutside = {
    mounted(el, binding) {
        el._clickOutside = (event) => {
            // Check if click was outside the element and its children
            if (!(el === event.target || el.contains(event.target))) {
                // Call the provided function
                binding.value(event);
            }
        };
        document.addEventListener('click', el._clickOutside);
    },
    unmounted(el) {
        // Clean up the event listener
        document.removeEventListener('click', el._clickOutside);
        delete el._clickOutside;
    }
};